export const DATA_TEST_IDS = {
    CONTAINER: "toggle-switch-container",
    BAR: "toggle-switch-bar",
    THUMB: "toggle-switch-thumb",
};
